// Handle rules + repo naming. The handle is the creator's short slug;
// it names the two repos and the default viewer URL
// (04_CREATOR_ONBOARDING.md → Step 3).
//
// We constrain harder than GitHub does: lowercase letters, digits, and
// single hyphens, 2-30 chars, no leading/trailing/double hyphen. That
// keeps repo names and the eventual `<handle>-bka-public.pages.dev`
// subdomain clean and predictable.

export const HANDLE_RE = /^[a-z0-9](?:[a-z0-9]|-(?=[a-z0-9])){1,29}$/;

export function isValidHandle(handle: string): boolean {
  return HANDLE_RE.test(handle);
}

/** Human-readable reason a handle is rejected, or null if it's valid. */
export function handleError(handle: string): string | null {
  if (handle.length === 0) return null; // empty = no error yet, just incomplete
  if (handle.length < 2) return "Too short — at least 2 characters.";
  if (handle.length > 30) return "Too long — 30 characters max.";
  if (handle !== handle.toLowerCase()) return "Lowercase only.";
  if (/[^a-z0-9-]/.test(handle)) return "Letters, digits, and hyphens only.";
  if (handle.startsWith("-") || handle.endsWith("-")) return "No leading or trailing hyphen.";
  if (handle.includes("--")) return "No double hyphens.";
  if (!HANDLE_RE.test(handle)) return "Not a valid handle.";
  return null;
}

export function privateRepoName(handle: string): string {
  return `${handle}-bka-private`;
}

export function publicRepoName(handle: string): string {
  return `${handle}-bka-public`;
}

/** The default viewer URL the creator gets before binding a domain. */
export function defaultSiteUrl(handle: string): string {
  return `https://${publicRepoName(handle)}.pages.dev`;
}
